import { PAGE_THEMES, DEFAULT_PAGE_THEME } from '~/constants/pageThemes'

export const isValidPageTheme = (themeToValidate) => {
  return Object.keys(PAGE_THEMES).includes(themeToValidate)
}

export const setPageTheme = (store, theme) => {
  const pageTheme = theme || DEFAULT_PAGE_THEME
  const validatedPageTheme = isValidPageTheme(pageTheme) ? pageTheme : DEFAULT_PAGE_THEME
  return store.dispatch('page/SET_PAGE_THEME', validatedPageTheme)
}
